import { render, staticRenderFns } from "./OrgHomeInventory.vue?vue&type=template&id=1b734b9e&scoped=true&"
import script from "./OrgHomeInventory.vue?vue&type=script&lang=js&"
export * from "./OrgHomeInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b734b9e",
  null
  
)

export default component.exports